<div class="py-20 bg-light">
  <div class="container mx-auto px-6 max-w-md">
    <div class="bg-white dark:bg-slate-800 p-8 rounded-xl shadow-lg dark:shadow-slate-900/50 border">
      <h2 class="text-3xl font-bold text-secondary text-center">
        Créer votre compte
      </h2>
      <p class="text-center text-gray-500 dark:text-gray-400 mt-2 mb-6">
        Rejoignez-nous et commencez à analyser vos documents en quelques
        secondes.
      </p>

      <!-- Message de succès -->
      @if (successMessage) {
        <div class="bg-green-100 dark:bg-green-900/30 border-l-4 border-green-500 text-green-700 dark:text-green-300 p-4 mb-6" role="alert">
          <p>{{ successMessage }}</p>
        </div>
      }

      <!-- Message d'erreur général -->
      @if (errorMessage) {
        <div class="bg-red-100 dark:bg-red-900/30 border-l-4 border-red-500 text-red-700 dark:text-red-300 p-4 mb-6" role="alert">
          <p>{{ errorMessage }}</p>
        </div>
      }

      <!-- Formulaire -->
      <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">

        <!-- Email -->
        <div class="mb-4">
          <label for="email" class="block text-gray-700 dark:text-gray-300 font-semibold mb-2">Email</label>
          <input type="email" id="email" formControlName="email"
            class="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
            placeholder="vous@exemple.com">
          @if (registerForm.get('email')?.invalid && registerForm.get('email')?.touched) {
            <p class="text-red-500 text-sm mt-1">
              @if (registerForm.get('email')?.errors?.['required']) {
                <span>L'email est requis.</span>
              }
              @if (registerForm.get('email')?.errors?.['email']) {
                <span>Veuillez entrer un email valide.</span>
              }
            </p>
          }
        </div>

        <!-- Mot de passe -->
        <div class="mb-4">
          <label for="password" class="block text-gray-700 dark:text-gray-300 font-semibold mb-2">Mot de passe</label>
          <input type="password" id="password" formControlName="password"
            class="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
            placeholder="Minimum 8 caractères">
          @if (registerForm.get('password')?.invalid && registerForm.get('password')?.touched) {
            <p class="text-red-500 text-sm mt-1">
              @if (registerForm.get('password')?.errors?.['required']) {
                <span>Le mot de passe est requis.</span>
              }
              @if (registerForm.get('password')?.errors?.['minlength']) {
                <span>Le mot de passe doit faire au moins 8 caractères.</span>
              }
              @if (registerForm.get('password')?.errors?.['pattern']) {
                <span>Doit contenir majuscule, minuscule, chiffre et symbole.</span>
              }
            </p>
          }
        </div>

        <!-- Confirmation mot de passe -->
        <div class="mb-4">
          <label for="confirmPassword" class="block text-gray-700 dark:text-gray-300 font-semibold mb-2">Confirmer le mot de passe</label>
          <input type="password" id="confirmPassword" formControlName="confirmPassword"
            class="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
            placeholder="********">
          @if (registerForm.get('confirmPassword')?.invalid && registerForm.get('confirmPassword')?.touched) {
            <p class="text-red-500 text-sm mt-1">
              @if (registerForm.get('confirmPassword')?.errors?.['required']) {
                <span>La confirmation est requise.</span>
              }
            </p>
          }
          @if (registerForm.hasError('passwordsMismatch') && registerForm.get('confirmPassword')?.touched) {
            <p class="text-red-500 text-sm mt-1">
              Les mots de passe ne correspondent pas.
            </p>
          }
        </div>

        <!-- Nom du business -->
        <div class="mb-4">
          <label for="businessName" class="block text-gray-700 dark:text-gray-300 font-semibold mb-2">Nom du business</label>
          <input type="text" id="businessName" formControlName="businessName"
            class="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
            placeholder="Nom de votre entreprise">
          @if (registerForm.get('businessName')?.invalid && registerForm.get('businessName')?.touched) {
            <p class="text-red-500 text-sm mt-1">
              @if (registerForm.get('businessName')?.errors?.['required']) {
                <span>Le nom du business est requis.</span>
              }
            </p>
          }
        </div>

        <!-- Acceptation CGU -->
        <div class="mb-6 flex items-center">
          <input type="checkbox" id="acceptedCGU" formControlName="acceptedCGU" class="mr-2">
          <label for="acceptedCGU" class="text-gray-700 dark:text-gray-300 font-semibold">J'accepte les <a href="/cgu" class="text-primary underline">CGU</a></label>
        </div>
        @if (registerForm.get('acceptedCGU')?.invalid && registerForm.get('acceptedCGU')?.touched) {
          <p class="text-red-500 text-sm mt-1">
            Vous devez accepter les CGU pour continuer.
          </p>
        }

        <!-- Bouton -->
        <button type="submit" [disabled]="registerForm.invalid || isLoading"
          class="w-full bg-purple-600 text-white font-semibold text-lg py-3 rounded-lg hover:bg-purple-700 transition-colors shadow-md dark:shadow-slate-900/50 disabled:bg-purple-300 disabled:cursor-not-allowed flex items-center justify-center">
          @if (isLoading) {
            <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span>Création du compte...</span>
          } @else {
            <span>Créer mon compte</span>
          }
        </button>
      </form>

      <p class="text-center text-gray-600 dark:text-gray-400 mt-6">
        Déjà un compte ?
        <a routerLink="/login" class="text-primary hover:underline font-semibold">Connectez-vous</a>
      </p>
    </div>
  </div>
</div>
